import {ErrorInfo} from "@firefly/fly-http";
import {AccessDeniedException, InsufficientAuthenticationException} from "../core";


export function onAccessDeniedHandler(reason: ErrorInfo | string) {
    let message: string;
    if (typeof reason === "string") {
        message = reason;
    } else {
        message = reason.message;
    }
    throw new AccessDeniedException(message, reason);
}

export function onInsufficientAuthenticationException(reason: ErrorInfo | string) {
    let message: string;
    if (typeof reason === "string") {
        message = reason;
    } else {
        message = reason.message;
    }
    throw new InsufficientAuthenticationException(message, reason);
}